import { InjectedStyledComponent } from '../InjectedStyledComponent';

const cssPrefix = `
	display: flex;
	width: 100%;
`;

export default InjectedStyledComponent('span', 'shared', ['dropdownButtonLabel'], ['appStore'], cssPrefix);